import React, { useEffect, useState } from 'react'
import { Container, Typography, withStyles } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import UserType from 'src/model/user-types'
import PLANS from './data'
import { Header, PricingCard, Enterprise, TableInvoice } from './components'
import style from './style'
import { loadStripe } from '@stripe/stripe-js'
import { roleTypes } from './data/pricing-json'
import {
  handlePortalRedirection,
  handleStripeCheckout,
  trackPlanUpgrade,
  getAction,
} from './logic'
import { meService } from 'src/api/authentication'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)

const Pricing = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const [timeInterval, setTimeInterval] = useState(true)
  const [starterPackage, setStarterPackage] = useState('')
  const [premiumPackage, setPremiumPackage] = useState('')
  const [premiumPlusPackage, setPremiumPlusPackage] = useState('')
  const [type, setType] = useState('')
  const [loading, setLoading] = useState(false)
  const [groupId, setGroupId] = useState(-1)

  const handleSetTimeInterval = newData => {
    setTimeInterval(newData)
  }

  const getGroupIdById = id => {
    const role = roleTypes.find(role => role.id === id)
    return role ? role.groupId : undefined
  }

  useEffect(() => {
    dispatch(
      componentBoxHideAction(),
      meService().then(response => {
        const userType = response.data.userRoleId

        setType(UserType[userType])

        const groupId = getGroupIdById(userType)
        setGroupId(groupId)

        setStarterPackage(
          UserType[userType] === 'Starter' ||
            UserType[userType] === 'Starter - A',
        )
        setPremiumPackage(
          ['Premium - A', 'Premium', 'Premium v2'].includes(UserType[userType]),
        )
        setPremiumPlusPackage(
          ['Premium Plus', 'Premium Plus v2', 'Elite'].includes(
            UserType[userType],
          ),
        )
      }),
    )
  }, [])

  const handleClick = async card => {
    setLoading(true)
    const { priceId, priceTrialDays, successReturnUrl, subscription } = card

    trackPlanUpgrade(subscription)

    try {
      if (groupId === 0) {
        await handleStripeCheckout(priceId, priceTrialDays, successReturnUrl)
        setLoading(false)
      } else if (groupId === 1 || groupId === 2 || groupId === 3) {
        await handlePortalRedirection()
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error('Plan upgrade error:', error)
    }
  }

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Header type={type} setData={handleSetTimeInterval} align="center" />
      <PricingCard
        plans={PLANS(
          timeInterval,
          starterPackage,
          premiumPackage,
          groupId,
          getAction,
        )}
        loading={loading}
        handleClick={handleClick}
      />
      <Enterprise />
      <div className={classes.rootHeader}>
        <Typography align="center" className={classes.typographyHeader}>
          Compare the features
        </Typography>
      </div>
      <TableInvoice
        plans={PLANS(
          timeInterval,
          starterPackage,
          premiumPackage,
          groupId,
          getAction,
        )}
        loading={loading}
        handleClick={handleClick}
      />
    </Container>
  )
}

export default withStyles(style)(Pricing)
